import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetch = (studentId: number): AxiosPromise<StudentCourseApi[]> => {
  return api.get<StudentCourseApi[]>(endpoints.STUDENT_COURSES.GET(studentId));
};

const register = (studentId: number, body: AdminRegisterUserToCourseRequest): AxiosPromise => {
  return api.post(endpoints.STUDENT_COURSES.REGISTER(studentId), body);
};

export const studentCoursesApi = {
  fetch,
  register,
};

export interface StudentCourseApi {
  courseId: number;
  name: string;
  registrationDate: Date;
  fullyPaid: boolean;
  paidAmount: number;
  totalPrice: number;
}

export interface AdminRegisterUserToCourseRequest {
  courseId: number;
  fields: { id: number; value: string | undefined }[];
  buyerFields: {
    buyer?: string;
    buyerNip?: string;
    buyerAddress?: string;
    isInvoice?: boolean;
  };
  urzadPracyFields: null;
}
